import { PayloadAction, createSelector, createSlice } from '@reduxjs/toolkit';
import { RootState } from 'app/store';
import { PathTimeCalculationTypes } from './paths.models';
import { PURGE } from 'redux-persist';

interface PathsTableState {
  currentPage: number;
  currentPageSize: number;
  pageSizes: number[];
  isIconOnly: boolean;
  selectedCalculationType: PathTimeCalculationTypes;
}

const initialState: PathsTableState = {
  currentPage: 1,
  currentPageSize: 50,
  pageSizes: [5, 10, 25, 50, 100],
  isIconOnly: false,
  selectedCalculationType: PathTimeCalculationTypes.Mean
};

const pathsTableSlice = createSlice({
  name: 'pathsTable',
  initialState,
  reducers: {
    onPreviousPage: (state) => {
      state.currentPage = state.currentPage - 1;
    },
    onNextPage: (state) => {
      state.currentPage = state.currentPage + 1;
    },
    onPageSizeChanged: (state, action: PayloadAction<number>) => {
      state.currentPageSize = action.payload;
      state.currentPage = 1;
    },
    onIsIconOnlyToggled: (state) => {
      state.isIconOnly = !state.isIconOnly;
    },
    onCalculationTypeChanged: (
      state,
      action: PayloadAction<PathTimeCalculationTypes>
    ) => {
      state.selectedCalculationType = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(PURGE, () => initialState);
  }
});

const { actions, reducer } = pathsTableSlice;

export const {
  onPreviousPage,
  onNextPage,
  onPageSizeChanged,
  onIsIconOnlyToggled,
  onCalculationTypeChanged
} = actions;

export default reducer;

export const selectPathsTableState = (state: RootState) => state.pathsTable;

export const selectIsIconOnly = createSelector(
  selectPathsTableState,
  (state) => state.isIconOnly
);

export const selectPathCalculationType = createSelector(
  selectPathsTableState,
  (state) => state.selectedCalculationType ?? PathTimeCalculationTypes.Mean
);
